import { useEffect, useState } from 'react';
import './UploadAllJobDetails.css'; 
import api from './api.js';
import apii from '../../Resume Components/Pages/Login and Sign UP/api.js' 

let UploadAllJobDetails=(props)=>{ 
    let [multipostdata, setmultipostdata] = useState(['']);
    let [singledata, setsingledata] = useState(['']);
    let [allservec, setallservec]= useState(['']);
    let [shopnmndaddr, setshopnmndaddr]= useState('');
    
    let [shopname , setshopname]= useState('');
    let [shopaddr , setshopaddr]= useState('');
    let [shopmobnum , setshopmobnum]= useState('');


    let [postid, setpostid]=useState('');
    let [jobtitle, setjobtitle]= useState('')
    let [applicationpostdate, setapplicationpostdate]= useState('')
    let [lastapplyonlinedate, setlastapplyonlinedate]= useState('')
    let [lastdateexaminationfee, setlastdateexaminationfee]= useState('')
    let [examinationdate, setexaminationdate]= useState('')
    let [examcitynotifydate, setexamcitynotifydate]= useState('')
    let [admitcardavailabledate, setadmitcardavailabledate]= useState('')
    let [resultavailabledate, setresultavailabledate]= useState('')
    let [answerkeyavailabledate, setanswerkeyavailabledate]= useState('')
    let [general, setgeneral]= useState('')
    let [scst, setscst]= useState('')
    let [allfemalecandidate, setallfemalecandidate]= useState('')
    let [payvia, setpayvia]= useState('')
    let [maximumage, setmaximumage]= useState('')
    let [minimumage, setminimumage]= useState('')
    let [totalpost, settotalpost]= useState('')
    let [applyonlinelink, setapplyonlinelink]= useState('')
    let [admitcarddownloadlink, setadmitcarddownloadlink]= useState('')
    let [resultdownloadlink, setresultdownloadlink]= useState('')
    let [officialwebsitelink, setofficialwebsitelink]= useState('')
    let [howtoonlinevideolink, sethowtoonlinevideolink]= useState('')
    let [correctiondate, setcorrectiondate]= useState('')
     


     let [username, setEnterName] = useState(''); 
      
    let [fullName, setfullName] = useState('');
    let [fathername, setFatherName] = useState('');
    let [mothername, setMotherName] = useState('');
    let [dob, setdob] = useState('');
    let [email, setEmailId] = useState('');  
    let [avatar, setavatar] = useState(null);
    let [id, setid] = useState('');

    let [singledocreq,setsingledocreq]=useState(['']);
    let [doc, setdoc] = useState(null);
    let [docpostid, setdocpostid] = useState(null);
    let [docid, setdocid] = useState(null);
    let [jobsitesrc, setjobsitesrc] = useState(null);
        

    let [multipostdatatoupdate,setmultipostdatatoupdate]=useState(['']);
    let [totalposttoupdate, settotalposttoupdate] = useState(null);
    let [postnametoupdate ,setpostnametoupdate] =useState(null);
    let [multipostidtoupdate, setmultipostidtoupdate] = useState(null);


    let [multipostdocreqtoupdate, setmultipostdocreqtoupdate]= useState(['']);
    let [multipostdocid, setmultipostdocid]= useState(null);
    let [multipostdoctoupdate, setmultipostdoctoupdate] = useState(null);
      

    
    let getsingledata = async()=>{
            const resp = await api.get('getsinglepostdata.php');
            setsingledata(resp.data.data)
        }
    let getallservices = async()=>{
        const resp = await api.get('getallservices.php');
        setallservec(resp.data.data);
    }
    let getshopnameandaddr=async()=>{
        try {
            const resp = await api.get('getshopnameaddr.php');
            setshopnmndaddr(resp.data.data);
        } catch (error) {
            console.log(error);
        }
    }
    let getmultipostdata =async()=>{
        const response = await api.get('getmultipostdata.php');
        setmultipostdata(response.data.data);
    }
// -------------------------------Resume site api started-------------
    

    let [resumeusers, setresumesusers] = useState(['']);
     const getallresumedata = async()=>{
        const res = await apii.get('Geltallresumeusers.php');
        
        setresumesusers(res.data.data);
    }
    let [customerImages, setcustomerimages] = useState(['']);
    const getallcustomersimages = async()=>{
        const res = await api.get('Geltallcustomersimages.php');
        
        setcustomerimages(res.data);
    } 
    let deleteresumeusers=async(e)=>{
        let deleteuserformdata= new FormData();
        deleteuserformdata.append('id', e.id);
       try {
         const res = await apii.post('deleteresumeusers.php', deleteuserformdata);
            props.Successandrerrorfun(res.data.result, "");
       } catch (error) {
            console.log(error);
       }
        
    }
    let selectresusertoshowdetails=(e)=>{
        setid(e.id);
        setEnterName(e.username);
        setfullName(e.fullName);
        setFatherName(e.fathername);
        setMotherName(e.mothername);
        setdob(e.dob);
        setEmailId(e.email);
        setavatar(e.avatar);
        document.querySelector(".resdataupdate").style.display="block";
        document.querySelector(".resuserdettable").style.display = "block";
        document.querySelector(".updateresdataformcont").style.display = "none";
        
    }
    let selectresuserstoeditdetails=(e)=>{
        setid(e.id);
        setEnterName(e.username);
        setfullName(e.fullName);
        setFatherName(e.fathername);
        setMotherName(e.mothername);
        setdob(e.dob);
        setEmailId(e.email);
        setavatar(e.avatar);
        document.querySelector(".resdataupdate").style.display="block";
        document.querySelector(".resuserdettable").style.display = "none";
        document.querySelector(".updateresdataformcont").style.display = "block";
    }

    let userupdateformsubmit=async(e)=>{
        e.preventDefault();
        const fromdata = new FormData();
        fromdata.append('id', id);
        fromdata.append('email', email)
        fromdata.append('username', username)
        fromdata.append('fullName', fullName)
        fromdata.append('fathername', fathername)
        fromdata.append('mothername', mothername)
        fromdata.append('dob', dob)

        try {
            const resp = await apii.post('/updateresumedetails.php', fromdata);
            props.Successandrerrorfun(resp.data.result, "");

        } catch (error) {
            console.log(error);
        }
 

    }
    let hideupdateusersdetailspage=()=>{
        document.querySelector(".resdataupdate").style.display="none";
    }



// --------------------------------------------------------------------------------

// ---------------------Applicants details apis work hare-------------------

let [appldet, setappldet]=useState(['']); 
let getapplicantsdetails=async()=>{
    try {
        let resp = await api.get('getallapplicantsdetails.php');
        setappldet(resp.data.data); 
    } catch (error) {
        console.log(error);
    }

 }

 let deleteapplicantdet=async(aa)=>{ 
    let applicantdetailsdeletedata = new FormData();
    applicantdetailsdeletedata.append('id', aa);

    try {
        let resp = await api.post('deleteapplicantsdetails.php', applicantdetailsdeletedata);  
        props.Successandrerrorfun(resp.data.result, "");
    } catch (error) {
        console.log(error);
    }
 }
 let unhideapplicantdet=()=>{
    document.querySelector(".applicanttablecont").style.display="block";
 }

    useEffect(()=>{
        getsingledata();
        getmultipostdata();
        getallresumedata();
        getallservices();
        getshopnameandaddr();
        getapplicantsdetails();
        getallcustomersimages();
    },[]);
    let[Inputs, setInputs]=useState();
  
    let Inputchangehandel = (e)=>{
        let name = e.target.name;
        let value = e.target.value;
        setInputs(Values => ({...Values, [name]: value}))
        
    }
     let clickchangehangel=(e)=>{
        if(e.target.innerHTML === "Add New job"){
            document.querySelector(".newaddvacancy").style.display = "block";
            document.querySelector(".delandupdatedata").style.display="none";
        }
        if(e.target.innerHTML === "Update and Delete job"){
            
            document.querySelector(".delandupdatedata").style.display="block";
            document.querySelector(".newaddvacancy").style.display = "none";
        }
        if(e.target.innerHTML === "Add New resuser"){
            
            // document.querySelector(".delandupdatedata").style.display="block";
            document.querySelector(".resuserreaddatatable").style.display = "none";
        }
        if(e.target.innerHTML === "Update and Delete resuser"){
            
            document.querySelector(".resuserreaddatatable").style.display="block";
            // document.querySelector(".newaddvacancy").style.display = "none";
        }
         

    }
    
    let Singleformsubmitfun= async(e)=>{
        e.preventDefault();
        let singlejobdata= new FormData();
        singlejobdata.append("jobtitle", Inputs.jobtitle);
        singlejobdata.append("applicationpostdate", Inputs.applicationpostdate);
        singlejobdata.append("lastapplyonlinedate", Inputs.lastapplyonlinedate);
        singlejobdata.append("lastdateexaminationfee", Inputs.lastdateexaminationfee);
        singlejobdata.append("examinationdate", Inputs.examinationdate);
        singlejobdata.append("examcitynotifydate", Inputs.examcitynotifydate);
        singlejobdata.append("admitcardavailabledate", Inputs.admitcardavailabledate);
        singlejobdata.append("resultavailabledate", Inputs.resultavailabledate);
        singlejobdata.append("answerkeyavailabledate", Inputs.answerkeyavailabledate);
        singlejobdata.append("correctiondate", Inputs.correctiondate);
        singlejobdata.append("general", Inputs.general);
        singlejobdata.append("scst", Inputs.scst);
        singlejobdata.append("allfemalecandidate", Inputs.allfemalecandidate);
        singlejobdata.append("payvia", Inputs.payvia);
        singlejobdata.append("maximumage", Inputs.maximumage);
        singlejobdata.append("minimumage", Inputs.minimumage);
        singlejobdata.append("totalpost", Inputs.totalpost);
        singlejobdata.append("applyonlinelink", Inputs.applyonlinelink);
        singlejobdata.append("admitcarddownloadlink", Inputs.admitcarddownloadlink);
        singlejobdata.append("resultdownloadlink", Inputs.resultdownloadlink);
        singlejobdata.append("officialwebsitelink", Inputs.officialwebsitelink);
        singlejobdata.append("howtoonlinevideolink", Inputs.howtoonlinevideolink);

        const res = await api.post("singlejobdata.php", singlejobdata)
        
        props.Successandrerrorfun(res.data.result, "");
        getsingledata();
        
        
       
    }
     
    let singlejobdocument=async(e)=>{
        e.preventDefault();
        let singlejobdoc= new FormData(); 
        singlejobdoc.append('postid', singledata[singledata.length-1].postid);
        singlejobdoc.append('documents', Inputs.documents);
        const res = await api.post('singlejobdocreq.php', singlejobdoc);
        props.Successandrerrorfun(res.data.result, "");
    }

    let Multipostdatafun=async(e)=>{
        e.preventDefault()
        let multipostdata = new FormData();
        multipostdata.append('postid', singledata[singledata.length-1].postid);
        multipostdata.append('postname', Inputs.postname);
        multipostdata.append('totalposts', Inputs.TotalPost);
        const res = await api.post('multipostdata.php', multipostdata);
        props.Successandrerrorfun(res.data.result, "");
        getmultipostdata();
        
         
    }
    let multipostdocreqfun=async(e)=>{
        e.preventDefault();
        let multipostdocreqdata = new FormData();
        multipostdocreqdata.append('multipostid', multipostdata[multipostdata.length-1]?.multipostid);
        multipostdocreqdata.append("documents", Inputs.multiplepostdocrequired)
        const res = await api.post('multipostdocreq.php', multipostdocreqdata);
        props.Successandrerrorfun(res.data.result, "");
    }




    let deletefun=async(e)=>{
        const singledatapostid = new FormData();
        singledatapostid.append("postid", e.postid);
        const response = await api.post("deletesingledata.php", singledatapostid);
        props.Successandrerrorfun(response.data.result, "");
        getsingledata();
         
    }
    let selectsingledata = async(e)=>{
        setpostid(e.postid);
        setjobtitle(e.jobtitle)
        setapplicationpostdate(e.applicationpostdate)
        setlastapplyonlinedate(e.lastapplyonlinedate)
        setlastdateexaminationfee(e.lastdateexaminationfee)
        setexaminationdate(e.examinationdate)
        setexamcitynotifydate(e.examcitynotifydate)
        setadmitcardavailabledate(e.admitcardavailabledate)
        setresultavailabledate(e.resultavailabledate)
        setanswerkeyavailabledate(e.answerkeyavailabledate)
        setgeneral(e.general)
        setscst(e.scst)
        setallfemalecandidate(e.allfemalecandidate)
        setpayvia(e.payvia)
        setmaximumage(e.maximumage)
        setminimumage(e.minimumage)
        settotalpost(e.totalpost)
        setapplyonlinelink(e.applyonlinelink)
        setadmitcarddownloadlink(e.admitcarddownloadlink)
        setresultdownloadlink(e.resultdownloadlink)
        setofficialwebsitelink(e.officialwebsitelink)
        sethowtoonlinevideolink(e.howtoonlinevideolink)
        setcorrectiondate(e.correctiondate)

        const singledocreqformdata = new FormData();
            singledocreqformdata.append('singlepostid', e.postid);
        try {
            const res= await api.post('getsinglepostdocreq.php', singledocreqformdata);
            setsingledocreq(res.data.data);
            console.log(res.data);
        } catch (error) {
            console.log(error);
        }


         const multipostformdata = new FormData();
            multipostformdata.append('singlepostid', e.postid);
        try {
            const res= await api.post('getmultipostdatabypostid.php', multipostformdata);
            
            setmultipostdatatoupdate(res.data.data);
        } catch (error) {
            console.log(error);
        }



       
        document.querySelector('.singledocshowtable').style.display="block";
        document.querySelector(".updatevacancy").style.display="block";
    }

    let updatesingledata= async(e)=>{
        e.preventDefault();
        let updateformdataforsingledata = new FormData();
        updateformdataforsingledata.append("postid", postid);
         updateformdataforsingledata.append("jobtitle", jobtitle);
        updateformdataforsingledata.append("applicationpostdate", applicationpostdate);
        updateformdataforsingledata.append("lastapplyonlinedate", lastapplyonlinedate);
        updateformdataforsingledata.append("lastdateexaminationfee", lastdateexaminationfee);
        updateformdataforsingledata.append("examinationdate", examinationdate);
        updateformdataforsingledata.append("examcitynotifydate", examcitynotifydate);
        updateformdataforsingledata.append("admitcardavailabledate", admitcardavailabledate);
        updateformdataforsingledata.append("resultavailabledate", resultavailabledate);
        updateformdataforsingledata.append("answerkeyavailabledate", answerkeyavailabledate);
        updateformdataforsingledata.append("correctiondate", correctiondate);
        updateformdataforsingledata.append("general", general);
        updateformdataforsingledata.append("scst", scst);
        updateformdataforsingledata.append("allfemalecandidate", allfemalecandidate);
        updateformdataforsingledata.append("payvia", payvia);
        updateformdataforsingledata.append("maximumage", maximumage);
        updateformdataforsingledata.append("minimumage", minimumage);
        updateformdataforsingledata.append("totalpost", totalpost);
        updateformdataforsingledata.append("applyonlinelink", applyonlinelink);
        updateformdataforsingledata.append("admitcarddownloadlink", admitcarddownloadlink);
        updateformdataforsingledata.append("resultdownloadlink", resultdownloadlink);
        updateformdataforsingledata.append("officialwebsitelink", officialwebsitelink);
        updateformdataforsingledata.append("howtoonlinevideolink", howtoonlinevideolink);
        const resp = await api.post("updatesingledata.php", updateformdataforsingledata);
        props.Successandrerrorfun(resp.data.result, "");

    } 
    let cancelfunc=()=>{
        document.querySelector(".updatevacancy").style.display="none";
    }

    let selectjobsspan=(e)=>{
        if(e.target.innerHTML === "Free Job Alert"){
            document.querySelector(".allvacsitescont").style.display = "block";
            setjobsitesrc('https://www.freejobalert.com/');
            document.querySelector(".frrjobalert").style.display= "block";
            document.querySelector(".rojgarresult").style.display= "none";

        }
        if(e.target.innerHTML === "RojgarResult"){
             document.querySelector(".allvacsitescont").style.display = "block";
             setjobsitesrc('https://www.rojgarresult.com/')
            document.querySelector(".rojgarresult").style.display= "block";
            document.querySelector(".frrjobalert").style.display= "none";
            
        }
        
    }
    let hidesitejob=()=>{
         document.querySelector(".allvacsitescont").style.display = "none";
         setjobsitesrc(null);
        // document.querySelector(".frrjobalert").style.display= "none";
        // document.querySelector(".rojgarresult").style.display= "none";
    }

    // -----------------single job doc req...  update codes-------------------

    let selectsingledocreq=(e)=>{
        setdoc(e.documents);
        setdocid(e.id)
        setdocpostid(e.postid)
        document.querySelector(".singledocupdateform").style.display="block";

    }
    let deletesingledocreq=async(e)=>{
        let deletesingledocreqformdata = new FormData();
        deletesingledocreqformdata.append('id',e);
       try {
         const resp = await api.post('deletesinglejobdocreq.php', deletesingledocreqformdata);
        props.Successandrerrorfun(resp.data.result, "");

       } catch (error) {
            console.log(error);
       }

    }
    let singlejobdocumentupdate=async(e)=>{
        e.preventDefault();
        let singledocupdateformdata = new FormData();
        singledocupdateformdata.append('docid', docid);
        singledocupdateformdata.append('postid', docpostid);
        singledocupdateformdata.append('document', doc);
       try {
         const resp = await api.post('updatesinglejobdocreq.php', singledocupdateformdata);
         props.Successandrerrorfun(resp.data.result, "");
       } catch (error) {
            console.log(error);
       }

    }

    // ----------------------------Multipost data update codes---------------------------

    let selectmultipostdatatoupdate=async(e)=>{
        document.querySelector(".multipostdataform").style.display="block";
        document.querySelector(".multipostdoctable").style.display="block";
        setpostnametoupdate(e.postname);
        settotalposttoupdate(e.totalposts);
        setmultipostidtoupdate(e.multipostid);

          const multipostdocreqtoupdate = new FormData();
            multipostdocreqtoupdate.append('multipostid', e.multipostid);
        try {
            const res= await api.post('getmultipostdocreqbyid.php', multipostdocreqtoupdate);
            
            setmultipostdocreqtoupdate(res.data.data);
        } catch (error) {
            console.log(error);
        }
    }
    let deletemultipostdata=async(e)=>{
         let deletemultipostdataformdata = new FormData();
        deletemultipostdataformdata.append('id',e);
       try {
         const resp = await api.post('deletemultipostdata.php', deletemultipostdataformdata);
         props.Successandrerrorfun(resp.data.result, "");
       } catch (error) {
            console.log(error);
       }
    }


    let selectmultipostdocstoupdate=(e)=>{
        document.querySelector(".multipostdocreqform").style.display="block";
        setmultipostdocid(e.id)
        setmultipostdoctoupdate(e.multiplepostdocrequired);
    }
    let deletemultipostdocreq=async(e)=>{
         let deletemultipostdocreqformdata = new FormData();
        deletemultipostdocreqformdata.append('id',e);
       try {
         const resp = await api.post('deletemultipostdocreq.php', deletemultipostdocreqformdata);
         document.querySelector(".multipostdocsdeletemsgshow").innerHTML = resp.data.result;
         setTimeout(() => {
             document.querySelector(".multipostdocsdeletemsgshow").innerHTML = "";
          }, 3000);
       } catch (error) {
            console.log(error);
       }
    }
    let Multipostdataupdatefun=async(e)=>{
        e.preventDefault(); 
        let multipostdatatoupdate = new FormData();
        multipostdatatoupdate.append('multipostid', multipostidtoupdate);
        multipostdatatoupdate.append('postname', postnametoupdate);
        multipostdatatoupdate.append('totalpost', totalposttoupdate); 
       try {
         const resp = await api.post('updatemultipostdata.php', multipostdatatoupdate);
         document.querySelector(".multipostdatamsgshow").innerHTML=resp.data.result;
          
          setTimeout(() => {
            document.querySelector(".multipostdatamsgshow").innerHTML="";
         }, 3000);
       } catch (error) {
            console.log(error);
       }

    }

    let multipostdocrequpdatefun=async(e)=>{
        e.preventDefault()
        let multipostdocrequpdateformdata=new FormData();
        multipostdocrequpdateformdata.append('id', multipostdocid)
        multipostdocrequpdateformdata.append('multiplepostdocrequired', multipostdoctoupdate);

        try {
            const resp = await api.post('updatemultipostdocreq.php' , multipostdocrequpdateformdata);
            props.Successandrerrorfun(resp.data.result, "");

        } catch (error) {
            console.log(error);
        }

    }

    // --------------------shop banner functions-----------------------

     
     

 
    
let [inputs, setunputs]=useState({});
let inputhandlechange=(e)=>{
   let name = e.target.name;
    let value = e.target.value;
    setunputs(values =>({...values, [name]: value}));
}
let [mdata, setmdata]=useState('')
    let submithandle=()=>{
        let data = {
            // Image : imge,
            vacancyname : inputs.vacancyname,
            Agelimit: inputs.agelimit,
            Lastdate: inputs.lastdate,
            Docreq : inputs.docreq,
            Tpost:inputs.tpost,
            Applicationfee: inputs.fee
        }
        setmdata(data)
        document.querySelector(".notifibanmaincont").style.display = "block";
        document.querySelector(".Fillmaincomp").style.display="none";

        
        
    }

   
    
    let latestnotfiposterfunction=()=>{
        document.querySelector(".Fillmaincomp").style.display="block";
        document.querySelector(".maindivpropic").style.display ="none"; 
        document.querySelector(".notifibanmaincont").style.display = "none";


    }
    let hidelatestnotificationposter=()=>{
        document.querySelector(".Fillmaincomp").style.display="none";
    }
    let shopsrvposter=()=>{
        document.querySelector(".maindivpropic").style.display ="block";
         document.querySelector(".Fillmaincomp").style.display="none";
    }
    let addnewserfunction=async(e)=>{
        e.preventDefault();
        let addnewformdata = new FormData();
        addnewformdata.append("newser", Inputs.newser);
        try {
            const resp = await api.post('addnewservice.php', addnewformdata);
            props.Successandrerrorfun(resp.data.result, "");
        } catch (error) {
            console.log(error);
        }
    }
    let addnewserbtn=()=>{
    document.querySelector(".addservicecon").style.display="block";
    document.querySelector(".shopndandaddrupdateinputs").style.display="none";


    }
    let deletesercices=()=>{
        const unhide = document.querySelectorAll(".unhidedelbtn");
        unhide.forEach(element => {
            element.style.display="block";
        });
    }
    let hideaddnewserpnl=()=>{
        document.querySelector(".addservicecon").style.display="none";
    }

    let selectotupdateshopnamendaddr=(shopdetails)=>{
        setshopname(shopdetails.shopname)
        setshopaddr(shopdetails.address)
        setshopmobnum(shopdetails.mobilenum)
        document.querySelector(".shopndandaddrupdateinputs").style.display="block";
        document.querySelector(".addservicecon").style.display="none";

        
    }
    let selectodeleteservices= async(d)=>{
        let servicesdeleteformdata=new FormData();
        servicesdeleteformdata.append('id', d);
        try {
           const resp = await api.post('deleteservices.php', servicesdeleteformdata); 
            props.Successandrerrorfun("", resp.data.result);

        } catch (error) {
            console.log(error);
        }
    }

    let submitformtoupdateshopdetails=async(e)=>{
        e.preventDefault()
        let shopdetformdata = new FormData();
        // shopdetformdata.append('',shopname);

        shopdetformdata.append('shopname',shopname);
        shopdetformdata.append('address', shopaddr);
        shopdetformdata.append('mobilenum', shopmobnum);

        try {
            const resp = await api.post('updateshopdetails.php', shopdetformdata);
            props.Successandrerrorfun(resp.data.result, "");

        } catch (error) {
            console.log(error)
        }
    }

    let hideupdateshopdet=()=>{
        document.querySelector(".shopndandaddrupdateinputs").style.display="none";
    }

    
    let deletecustomerimages=async(aa)=>{
        let delid = new FormData();
        delid.append("id", aa.id);
        const resp = await api.post('deletecustomersimages.php', delid);
        console.log(resp.data);
        props.Successandrerrorfun("", resp.data.result);
         
       
    }



    return(
        <div className='uploadjobsdetailsmaincont'>
            <div className='getdocuments'>
                <h2 className='getdocheading'>Documents from Customers</h2>
                {
                      customerImages.map(
                         aa=>(
                        <div className='imgcont'>
                            <img alt='pic' className='immgg' src={'https://makeeasyway.in/jobSiteData/'+aa?.Images}/>
                            <div className='operationscont'>
                                <span><a href={'https://makeeasyway.in/jobSiteData/'+aa?.Images}>download</a></span>
                                <span style={{cursor:"pointer"}} onClick={()=>(deletecustomerimages(aa))}>Delete</span>
                            </div>

                        </div>
                        )
                    ) 
                }
                
            </div>
            <div className='formfillerapplicantdetcont'>
                <h3 className='applicantheading'>Form Filler Applicant Details</h3>
                <p style={{textAlign:"center"}}><span style={{border:"1px solid black", padding:"10px", borderRadius:"5px", fontSize:"20px",cursor:"pointer"}} onClick={unhideapplicantdet}>Applicant Details(Read, Delete)</span></p>
                <div style={{display:"none", overflowY:"scroll"}} className='applicanttablecont'>
                    
                    <table className='applicanttable'>
                        <thead>
                            <tr>
                                <th>Applicant Name</th>
                                <th>Email-Id</th>
                                <th>Mobile Number</th>
                                <th>Password</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            appldet[0] !== '' ?  appldet.map(
                                aa=>(
                                    
                                        <tr key={aa.id+1}>
                                            <td>{aa.applicantname}</td>
                                            <td>{aa.emailid}</td>
                                            <td>{aa.mobilenum}</td>
                                            <td>{aa.password}</td>
                                            <td><button onClick={()=>{deleteapplicantdet(aa.id)}}>Delete</button></td>
                                        </tr>
                                    
                                )
                            ) : <tr> 
                                <td colSpan="5">
                                    <p style={{textAlign:"center"}}>No any applicants found</p>
                                </td>
                            </tr> 
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='shopbannercont'>
                    <h3 style={{textAlign:"center", width:"100%", margin:"0", backgroundColor:"gainsboro", padding:"10px"}}>Shop Services</h3>

                <div className='btncont'>
                    <button className='unhidemakelatvacposter' onClick={latestnotfiposterfunction}>Make Latest Vacancy Notification Poster</button>
                    <button className='unhidemakelatvacposter' onClick={shopsrvposter}>Shop Services Poster</button>
                </div>




                <div style={{display:"none"}} className="Fillmaincomp">
                    <h3 className='hidemakelatestvac'><span style={{cursor:"pointer", color:"red"}} onClick={hidelatestnotificationposter}>X</span></h3>
                    {/* <input onChange={imagechangehandle} type='file'/> */}
                    <input onChange={inputhandlechange} name='vacancyname' type='text' placeholder='Enter Vacancy Name'/>
                    <input placeholder='Age Limet' onChange={(e)=>{inputhandlechange(e)}} name='agelimit'  type='text'/>
                    <input placeholder='Last Date Applying Online' onChange={(e)=>{inputhandlechange(e)}} name='lastdate' type='text'/>
                    <input placeholder='Eligibility Criteria'  onChange={(e)=>{inputhandlechange(e)}} name='docreq' type='text'/>
                    <input placeholder='Total posts' onChange={(e)=>{inputhandlechange(e)}} name='tpost' type='text'/>
                    <input placeholder='Application Fee' onChange={(e)=>{inputhandlechange(e)}} name='fee' type='text'/>
                    <button className='submittbtn' onClick={submithandle}>Submit</button>
                </div>


                <div className='notifibanmaincont'>
                    <p className='notiheading'>Notification</p>
                    <span className='imgcont'>
                        <p className='vacancynameptag'>{mdata.vacancyname}</p>
                        {/* <img  src={mdata.Image}/> */}
                    </span>
                    <table className='vacdettable'>
                        <thead> 
                            <tr>
                                <td>Last Date Apply Online:-</td>
                                <td>{mdata.Lastdate}</td>
                            </tr>
                            <tr>
                                <td style={{borderTop:"1px solid black"}}>Age Limit:-</td>
                                <td style={{borderTop:"1px solid black"}}>{mdata.Agelimit}</td>
                            </tr>
                            <tr>
                                <td>Eligibility Criteria:-</td>
                                <td>{mdata.Docreq}</td>
                            </tr>
                            <tr>
                                <td>Total Posts:-</td>
                                <td>{mdata.Tpost}</td>
                            </tr>
                            <tr>
                                <td>Application Fee:-</td>
                                <td>{mdata.Applicationfee}</td>
                            </tr>
                        </thead>
                    </table>
                </div>

                <div style={{display:"none"}} className='maindivpropic'>
                    <p className='heading'>{shopnmndaddr.shopname}</p>
                    <div className='servicescont'>
                        {
                            allservec.map(
                                xx=>(
                                    <span key={xx.id+1} className='spanserv'>{xx.newser}<span key={xx.id} onClick={()=>{selectodeleteservices(xx.id+2)}}style={{cursor:"pointer", display:"none"}} className='unhidedelbtn'>--X</span></span>
                                )
                            )
                        }
                        <span className='spanserv'>Address:- {shopnmndaddr.address} Mob No:- {shopnmndaddr.mobilenum}</span>
                        
                    </div>
                    <div style={{display:"none"}} className='addservicecon'>
                        <h3>Add New Services <span style={{cursor:"pointer"}} onClick={hideaddnewserpnl}>X</span></h3>
                        <p className='sucmsg'></p>
                        <form onSubmit={addnewserfunction} className='inputcontservadd'>
                            <input name='newser' onChange={Inputchangehandel} type='text' placeholder='Enter Service Name'/>
                            <input type='submit' value="Add"/>
                        </form>

                    </div>
                    <div style={{display:"none"}} className='shopndandaddrupdateinputs'>
                        <p className='shopmsgupdateshopdet'></p>
                    <h3 className='updateshopdetheading'>Update shop Details---<span style={{cursor:"pointer"}} onClick={hideupdateshopdet}>X</span></h3>
                        <form className='updateshopdetinputformcont' onSubmit={submitformtoupdateshopdetails}>
                            <input value={shopname} onChange={(e)=>{setshopname(e.target.value)}} type='text' placeholder='shop name'/>
                            <input value={shopaddr} onChange={(e)=>{setshopaddr(e.target.value)}} type='text' placeholder='shop addr'/>
                            <input type='text' onChange={(e)=>{setshopmobnum(e.target.value)}} value={shopmobnum} placeholder='number'/>
                            <input type='submit' value="Update"/>
                        </form>
                    </div>
                     <div className='adddeleteservicesbtn'>
                        <button onClick={addnewserbtn} className='addser smd'>Add Services</button>
                        <button onClick={deletesercices} className='delser smd'>Delete Services</button>
                        <button onClick={()=>{selectotupdateshopnamendaddr(shopnmndaddr)}} className='delser smd'>Update shop name & addrs </button>


                    </div>
                </div>

            </div>
{/* -------------------Resume site api crud operations--------------------- */}
            <h2 style={{textAlign:"center"}} className='resapioperhead'>Resume site api Operations</h2>
            <div className='resapidivcont'>
                
                <div className='crudcont' style={{border:"1px solid black"}}>
                    <h3 className='crudophead'>CRUD Operatins on ResumeSite</h3>
                    <div className='subcrudcont'>
                        <span onClick={clickchangehangel}>Add New resuser</span>
                        <span onClick={clickchangehangel}>Update and Delete resuser</span>
                    </div>
                </div>
{/* ---------------------------Resume Data read and delete------------------------------- */}
                <table className='resuserreaddatatable' style={{display:"none"}}>
                    <p style={{textAlign:"center"}} className='deleteresusersdetails'></p>
                    {
                        resumeusers !== undefined ? <caption>Total Users:-{resumeusers.length}</caption> : <caption>No Any Users</caption>
                    }
                    
                    <thead>
                        <tr>
                            <th>UserName</th>
                            <th>EmailId</th>
                            <th>FatherName</th>
                            <th colSpan="3">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            resumeusers !== undefined ? resumeusers.map(
                                dd=>(
                                    <tr key={dd.id+1}>
                                        <td>{dd.username}</td>
                                        <td>{dd.email}</td>
                                        <td>{dd.fathername}</td>
                                        <td><button onClick={()=>{selectresusertoshowdetails(dd)}}>See Full Details</button></td>
                                         <td><button onClick={()=>{selectresuserstoeditdetails(dd)}}>Edit</button></td>
                                        <td><button onClick={()=>{deleteresumeusers(dd)}}>Delete</button></td>
                                    </tr>
                                )
                            ) : ""
                        }
                        
                    </tbody>
                </table>
{/* ------------------------------Resume data update---------------------------------- */}
                <div style={{display:"none"}} className='resdataupdate'>
                    <p onClick={hideupdateusersdetailspage} style={{textAlign:"right",cursor:"pointer", padding:"5px", margin:"0"}}>X</p>
                    <table className='resuserdettable' style={{display:"none"}}>
                        <p style={{textAlign:"center",margin:"0",padding:"5px", fontSize:"23px",backgroundColor:"gainsboro"}}>Resume Users Full Details</p>
                        <caption>Registration Details</caption>
                        <thead>
                            <tr>
                                <th colSpan="2">UserDetails</th>
                                <th>Photo</th>
                            </tr>
                        </thead>
                        <tbody>
                             <tr>
                                <td colSpan="2">
                                    <tr>
                                        <td>UserNAME</td>
                                        <td>{username}</td>
                                    </tr>
                                </td>
                                <td rowSpan="6"> <img style={{width:"160px", height:"160px", backgroundSize:"cover"}} alt='propic' src={"https://makeeasyway.in/resumeData/"+avatar}/></td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <tr>
                                        <td>Name</td>
                                        <td>{fullName}</td>
                                    </tr>
                                </td>
                               
                            </tr>
                             <tr>
                                <td colSpan="2">
                                    <tr>
                                        <td>FatherName</td>
                                        <td>{fathername}</td>
                                    </tr>
                                </td>
                               
                            </tr>
                             <tr>
                                <td colSpan="2">
                                    <tr>
                                        <td>MotherName</td>
                                        <td>{mothername}</td>
                                    </tr>
                                </td>
                               
                            </tr>
                             <tr>
                                <td colSpan="2">
                                    <tr>
                                        <td>Dob:-</td>
                                        <td>{dob}</td>
                                    </tr>
                                </td>
                              
                            </tr>
                            
                             <tr>
                                <td colSpan="2">
                                    <tr>
                                        <td>Email-Id:-</td>
                                        <td>{email}</td>
                                    </tr>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <form onSubmit={userupdateformsubmit} className='updateresdataformcont' style={{display:"none"}}>
                        <p style={{textAlign:"center"}} className='resuserupdatemsgshow'></p>
                        <p style={{textAlign:"center",margin:"0",padding:"5px", fontSize:"23px",backgroundColor:"gainsboro"}}>Update Resume Users Data</p>
                    <span>
                        {
                            "https://makeeasyway.in/resumeData/"+avatar !== "" ? <img alt='avatar'  style={{width:"160px", height:"160px", backgroundSize:"cover"}} src={"https://makeeasyway.in/resumeData/"+avatar}/> : <img alt='avatar' src={avatar}/>

                        }
                        
                    </span>

                    <input className='form_inputs' type='text' value={username} name='UserName' onChange={(event)=>setEnterName(event.target.value)}  placeholder='User Name'/>
        
                    <input className='form_inputs' type='text' value={fullName} name='fullName' onChange={(event)=>setfullName(event.target.value)}  placeholder='Full name'/>

                    <input className='form_inputs' value={email} required type='text' name='EmailID' onChange={(event)=>setEmailId(event.target.value)} placeholder='EMAIL' />


                    <input className='form_inputs' type='date' value={dob} name='dob' onChange={(event)=>setdob(event.target.value)}  placeholder='Date Of Birth'/> 

                   


                    <input className='form_inputs' type='text' value={fathername} name='FatherName' onChange={(event)=>setFatherName(event.target.value)}  placeholder='Father Name'/>
                    
                    <input className='form_inputs' type='text' value={mothername} name='mothername' onChange={(event)=>setMotherName(event.target.value)}  placeholder='mother Name'/>

                    

                    <input type='submit' name='submit' value="Update Users Details" className='form_submitbtn'/>
                    
                    </form>
                </div>
            </div>
<hr></hr>
{/* ------------------------------end------------------------------------------ */}
{/* ------------------------CRUD OPERATIONS ARE FULLY COMPLETED------------------  */}
            <h1 className='uploadjobmainheading'>Vacancy Details(Add New, Read Vacancies, Update, Delete)</h1>
            <p className='actionscontptag'>
                <span onClick={clickchangehangel}>Add New job</span>
                <span onClick={clickchangehangel}>Update and Delete job</span>
                    
            </p>
{/* -----------------------Add new vacancy in database---------------------------- */}
            <div className='newaddvacancy' style={{border:"1px solid black", display:"none"}}>
                <h2 style={{textAlign:"center"}}>All vacancies sites at one place</h2>
                <div className='Selectjobsitecont'>
                    <span onClick={selectjobsspan}>Free Job Alert</span>
                    <span onClick={selectjobsspan}>RojgarResult</span>
                    {/* <span onClick={selectjobsspan}>SarkariResult</span>  */}

                </div>
                <div style={{display:"none", border:"2px solid black", padding:"0px 5px"}} className='allvacsitescont'>
                    <p  style={{textAlign:"right", padding:"8px 15px", margin:"0"}}><span style={{cursor:"pointer"}} onClick={hidesitejob}>X</span></p>
                    <iframe
                    style={{display:"none"}}
                    className='rojgarresult'
                        src={jobsitesrc}
                        width="100%"
                        height="250"
                        title="Example Iframe"
                    ></iframe>
                    <iframe
                    className='frrjobalert'
                    style={{display:"none"}}
                        src={jobsitesrc}
                        width="100%"
                        height="250"
                        title="Example Iframe"
                    ></iframe>
                </div>
                <hr></hr>

                <form onSubmit={Singleformsubmitfun} style={{textAlign:"center"}} className='addsinglejobdataformcont'>
                    <h3>Single Job Data</h3>
                    <p className='showmes'></p>
                    <input name='jobtitle' onChange={Inputchangehandel} type='text' placeholder='Job Title'/>
                    <input name='applicationpostdate' onChange={Inputchangehandel}  type='text' placeholder='Application Post Date'/>
                    <input name='lastapplyonlinedate'  onChange={Inputchangehandel}  type='text' placeholder='Last Apply Online Date'/>
                    <input name='lastdateexaminationfee'  onChange={Inputchangehandel}  type='text' placeholder='Last Date Examination Fee Pay'/>
                    <input name='correctiondate'  onChange={Inputchangehandel}  type='text' placeholder='Correction last date'/>
                    <input name='examinationdate'  onChange={Inputchangehandel}  type='text' placeholder='Examination Date'/>
                    <input name='examcitynotifydate'  onChange={Inputchangehandel}  type='text' placeholder='Exam City Notify Date'/>
                    <input  name='admitcardavailabledate'  onChange={Inputchangehandel}  type='text' placeholder='Admitcard Available Date'/>
                    <input  name='resultavailabledate'  onChange={Inputchangehandel}  type='text' placeholder='Result Available Date'/>
                    <input name='answerkeyavailabledate'  onChange={Inputchangehandel}  type='text' placeholder='Answer key available Date'/>
                    <input name='general'  onChange={Inputchangehandel}  type='text' placeholder='Genera/Obc'/>
                    <input name='scst'  onChange={Inputchangehandel}  type='text' placeholder='Sc/St'/>
                    <input name='allfemalecandidate'  onChange={Inputchangehandel}  type='text' placeholder='All Female Candidate'/>
                    <input name='payvia'  onChange={Inputchangehandel}  type='text' placeholder='Pay Via'/>
                    <input name='maximumage'  onChange={Inputchangehandel}  type='text' placeholder='Maximum Age'/>
                    <input name='minimumage'  onChange={Inputchangehandel}  type='text' placeholder='Minimum Age'/>
                    <input name='totalpost'  onChange={Inputchangehandel}  type='text' placeholder='Total Posts'/>

                    <input name='applyonlinelink'  onChange={Inputchangehandel}  type='text' placeholder='Apply online Link'/>
                    <input name='admitcarddownloadlink'  onChange={Inputchangehandel}  type='text' placeholder='Admit card Download Link'/>
                    <input name='resultdownloadlink'  onChange={Inputchangehandel}  type='text' placeholder='Result Download Link'/>
                    <input name='officialwebsitelink'  onChange={Inputchangehandel}  type='text' placeholder='Official website Link'/>
                    <input name='howtoonlinevideolink'   onChange={Inputchangehandel} type='text' placeholder='How To Online Video Link'/>
                    <div style={{margin:"10px"}}>
                    <input type='submit' value="Submit"/>
                    </div>
                </form>
                <hr></hr>
                <form onSubmit={singlejobdocument} style={{textAlign:"center"}}>
                    <h3>Single job Documents Required Field</h3>
                    <p className='singlejobdocreq'></p>
                    <input readOnly type='text' placeholder='single job ID' value={singledata !== undefined ? 'Post Id :'+singledata[singledata.length-1]?.postid : "PostId : NA" }/>

                  
                    <input name='documents' onChange={Inputchangehandel} type='text' placeholder='Enter Documents'/>
                    <div style={{margin:"10px"}}>
                    <input type='submit' value="Submit"/>
                    </div>
                </form>
                <hr></hr>
                <form onSubmit={Multipostdatafun} style={{textAlign:"center"}}>
                    <h3>Multipost Data</h3>
                    <p className='multipostdata'></p>
                    <input readOnly type='text' placeholder='single job ID' value={singledata !== undefined ? 'Post Id : '+singledata[singledata.length-1]?.postid:"PostId : NA"}/>
                    
                    <input name='postname' onChange={Inputchangehandel} type='text' placeholder='Post Name'/>
                    <input name='TotalPost' onChange={Inputchangehandel} type='text' placeholder='Total Posts'/>
                    
                    <div style={{margin:"10px"}}>
                    <input type='submit' value="Submit"/>
                    </div>
                </form>

                <form onSubmit={multipostdocreqfun}>
                    <div style={{textAlign:"center"}}>
                        <h3>Multiposts Documents Upload</h3>
                        <p className='multiposdocreq'></p>
                        <input readOnly type='text' placeholder='single job ID' value={multipostdata!==undefined ?  'Multipost Id : '+multipostdata[multipostdata.length-1]?.multipostid: "Multipost Id : NA"}/>
                        
                        <input name='multiplepostdocrequired' onChange={Inputchangehandel} type='text' placeholder='Enter Documents'/>
                        <input type='submit' value="Submit"/>
                    </div>
                </form>
            </div>

{/* -------------------Get all single data and do actions------------------ */}
            <div className='delandupdatedata' style={{display:"none"}}>
                <p className='vacancydeletemsgshow' style={{textAlign:"center", color:"green", fontSize:"20px", fontWeight:"bold"}}></p>
               <table>
                {
                    singledata !== undefined ? <caption style={{border:"1px solid black", padding:"10px 5px", backgroundColor:"yellow", color:"black", fontSize:"19px", fontWeight:"normal"}}>Total Vacancies: {singledata.length}</caption> : <caption>vacancy not available</caption>
                } 
                
                <thead>
                    <tr>
                         <th>jobtitle</th>
                          <th style={{backgroundColor:"yellow"}}>Apply Online link</th>
                          <th style={{backgroundColor:"yellow"}}>Admit card Download link</th>
                          <th style={{backgroundColor:"yellow"}}>Result Download link</th>
                          <th>Admitcard Avl Date</th>
                          <th>Examination Date</th>
                          <th>Answerkey Avl Date</th>
                          <th>Result Avl Date</th>
                          <th colSpan="2">Actions</th>
                    </tr> 
                </thead>
                <tbody>
                     {
                   singledata!==undefined ? singledata.map(
                        dd=>(
                            <tr key={dd.postid+1}>
                                <td>{dd.jobtitle}</td>
                                <td>{dd.applyonlinelink}</td>
                                <td>{dd.admitcarddownloadlink}</td>
                                <td>{dd.resultdownloadlink}</td>
                                <td>{dd.admitcardavailabledate}</td>
                                <td>{dd.examinationdate}</td>
                                <td>{dd.answerkeyavailabledate}</td>
                                <td>{dd.resultavailabledate}</td>
                                
                                
                                <td><button onClick={()=>{selectsingledata(dd)}}>Edit</button></td>
                                 <td><button onClick={()=>{deletefun(dd)}}>Delete</button></td>
                            </tr>
                        )
                    ) : ""
                }
                   
                </tbody>
               </table>
            </div>
{/* ------------------------Single data Update html----------------------------- */}
            <div className='updatevacancy' style={{border:"2px solid black", display:"none" , marginTop:"20px"}}>
                <p style={{textAlign:"right", padding:"0 20px", cursor:"pointer", fontWeight:"bold"}} onClick={cancelfunc}>X</p>
                <form onSubmit={updatesingledata} style={{textAlign:"center"}} className='updaesinglejobformcont'>
                    <h3>Single Job Data</h3>
                    <p className='singlejoddatamsgsow' style={{textAlign:"center", color:"green",fontSize:"20px", fontWeight:"bold"}}></p>
                    <p className='showmes'></p>
                    <input name='jobtitle' value={jobtitle} onChange={(e)=>{setjobtitle(e.target.value)}} type='text' placeholder='Job Title'/>
                    <input name='applicationpostdate' value={applicationpostdate} onChange={(e)=>{setapplicationpostdate(e.target.value)}}  type='text' placeholder='Application Post Date'/>
                    <input name='lastapplyonlinedate' value={lastapplyonlinedate}  onChange={(e)=>{setlastapplyonlinedate(e.target.value)}}  type='text' placeholder='Last Apply Online Date'/>
                    <input name='lastdateexaminationfee' value={lastdateexaminationfee}  onChange={(e)=>{setlastdateexaminationfee(e.target.value)}}  type='text' placeholder='Last Date Examination Fee Pay'/>
                    <input name='correctiondate' value={correctiondate} onChange={(e)=>{setcorrectiondate(e.target.value)}}  type='text' placeholder='Correction last date'/>
                    <input name='examinationdate' value={examinationdate} onChange={(e)=>{setexaminationdate(e.target.value)}}  type='text' placeholder='Examination Date'/>
                    <input name='examcitynotifydate' value={examcitynotifydate}  onChange={(e)=>{setexamcitynotifydate(e.target.value)}}  type='text' placeholder='Exam City Notify Date'/>
                    <input  name='admitcardavailabledate' value={admitcardavailabledate}  onChange={(e)=>{setadmitcardavailabledate(e.target.value)}}  type='text' placeholder='Admitcard Available Date'/>

                    <input  name='resultavailabledate' value={resultavailabledate}  onChange={(e)=>{setresultavailabledate(e.target.value)}}  type='text' placeholder='Result Available Date'/>

                    <input name='answerkeyavailabledate' value={answerkeyavailabledate}  onChange={(e)=>{setanswerkeyavailabledate(e.target.value)}}  type='text' placeholder='Answer key available Date'/>


                    <input name='general' value={general}  onChange={(e)=>{setgeneral(e.target.value)}}  type='text' placeholder='Genera/Obc'/>
                    <input name='scst' value={scst} onChange={(e)=>{setscst(e.target.value)}}  type='text' placeholder='Sc/St'/>
                    <input name='allfemalecandidate' value={allfemalecandidate}  onChange={(e)=>{setallfemalecandidate(e.target.value)}}  type='text' placeholder='All Female Candidate'/>
                    <input name='payvia' value={payvia}  onChange={(e)=>{setpayvia(e.target.value)}}  type='text' placeholder='Pay Via'/>
                    <input name='maximumage' value={maximumage}  onChange={(e)=>{setmaximumage(e.target.value)}}  type='text' placeholder='Maximum Age'/>
                    <input name='minimumage' value={minimumage}  onChange={(e)=>{setminimumage(e.target.value)}}  type='text' placeholder='Minimum Age'/>
                    <input name='totalpost' value={totalpost} onChange={(e)=>{settotalpost(e.target.value)}}  type='text' placeholder='Total Posts'/>
                    
                    <input name='applyonlinelink' value={applyonlinelink}  onChange={(e)=>{setapplyonlinelink(e.target.value)}}  type='text' placeholder='Apply online Link'/>
                    <input name='admitcarddownloadlink' value={admitcarddownloadlink}  onChange={(e)=>{setadmitcarddownloadlink(e.target.value)}}  type='text' placeholder='Admit card Download Link'/>
                    <input name='resultdownloadlink' value={resultdownloadlink}  onChange={(e)=>{setresultdownloadlink(e.target.value)}}  type='text' placeholder='Result Download Link'/>
                    <input name='officialwebsitelink' value={officialwebsitelink}  onChange={(e)=>{setofficialwebsitelink(e.target.value)}}  type='text' placeholder='Official website Link'/>
                    <input name='howtoonlinevideolink' value={howtoonlinevideolink}   onChange={(e)=>{sethowtoonlinevideolink(e.target.value)}} type='text' placeholder='How To Online Video Link'/>
                    <div style={{margin:"10px"}}>
                    <input type='submit' value="Update"/>
                    
                    </div>
                </form>
                <hr></hr>
                <table style={{display:"none"}} className='singledocshowtable'> 
                    <caption style={{textAlign:"center", color:"red", fontSize:"20captionx", fontWeight:"bold"}} className='singlejobdocsdeletemsgshow'></caption>
                    <caption>Single job Documents</caption>
                    
                    <thead>
                        <tr>
                            <th>Single Job ID</th>
                            <th>Documents Id</th>
                            <th>Documents</th>
                            <th colSpan="2">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            singledocreq[0]!=="" ? singledocreq.map(
                                dd=>(
                                    <tr key={dd.id+1}>
                                        <td>{dd.postid}</td>
                                        <td>{dd.id}</td>
                                        <td>{dd.documents}</td>
                                        <td><button onClick={()=>{selectsingledocreq(dd)}}>Edit</button></td>
                                        <td><button onClick={()=>{deletesingledocreq(dd.id)}}>Delete</button></td>
                                    </tr>
                                )
                            ) : <tr>
                                <td style={{color:"red"}} colSpan="5">**Single post Documents ane not available**</td>
                            </tr>
                        }
                        
                    </tbody>
                </table>
                <form onSubmit={singlejobdocumentupdate} className='singledocupdateform' style={{textAlign:"center", display:"none"}}>
                    <h2 className='singlejobdocreq'>Single job Documents to update</h2>
                    <p className='singlejobdocreqmsgshow' style={{textAlign:"center", color:"green", fontSize:"20px", fontWeight:"bold"}}></p>
                    <input readOnly type='text' placeholder='single job ID' value={docid !== undefined ?'Post Id : '+docid : "PostId : NA"}/>
                    <input name='documents' value={doc}  onChange={(e)=>{setdoc(e.target.value)}} type='text' placeholder='Enter Documents'/>
                    <div style={{margin:"10px"}}>
                    <input type='submit' value="Update Single Job Documents"/>
                    </div>
                </form>
                <hr></hr>
                <table className='multipostdatatable'>
                    <caption className='multipostdatadeletemsgshow' style={{textAlign:"center", color:"green", fontSize:"20px", fontWeight:"bold"}}></caption>
                    <caption>Multipost Data</caption>
                    <thead>
                        <tr>
                            <th>Single post id</th>
                            <th>Multipost id</th>
                            <th>PostName</th>
                            <th>TotalPost</th>
                            <th colSpan="2">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            multipostdatatoupdate[0] !== "" ? multipostdatatoupdate.map(
                                dd=>(
                                    <tr key={dd.postid+1}>
                                        <td>{dd.postid}</td>
                                        <td>{dd.multipostid}</td>
                                        <td>{dd.postname}</td>
                                        <td>{dd.totalposts}</td>
                                        <td><button onClick={()=>{selectmultipostdatatoupdate(dd)}}>Edit</button></td>
                                        <td><button onClick={()=>{deletemultipostdata(dd.multipostid)}} >Delete</button></td>
                                    </tr>
                                )
                            ) : <tr>
                                    <td  style={{color:"red"}}  colSpan="6">**Multipost Data not available** </td>
                                </tr>  
                        }
                       
                    </tbody>
                </table>
                <form className='multipostdataform' onSubmit={Multipostdataupdatefun} style={{textAlign:"center", display:"none"}}>
                    <h3>Multipost Data Update</h3>
                    <p className='multipostdatamsgshow' style={{textAlign:"center", color:"green", fontSize:"20px", fontWeight:"bold"}}></p>
                    <p className='multipostdata'></p>
                    <input readOnly type='text' placeholder='single job ID' value={multipostidtoupdate !== undefined ?'Post Id : '+multipostidtoupdate : "PostId : NA"}/>
                    <input name='postname' value={postnametoupdate} onChange={(e)=>{setpostnametoupdate(e.target.value)}} type='text' placeholder='Post Name'/>
                    <input name='TotalPost' value={totalposttoupdate} onChange={(e)=>{settotalposttoupdate(e.target.value)}} type='text' placeholder='Total Posts'/>
                    
                    <div style={{margin:"10px"}}>
                    <input type='submit' value="Update"/>
                    </div>
                </form>
                <hr></hr>

                
                <table className='multipostdoctable' style={{width:"100%", display:"none"}}>
                    <caption className='multipostdocsdeletemsgshow' style={{textAlign:"center", color:"green",fontSize:"20px", fontWeight:"bold"}}></caption>
                    <caption>Multipost Documents</caption>
                    <thead>
                        <tr>
                            <th>MultipostdocreqId</th>
                            <th>Documents</th>
                            <th colSpan="2">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            multipostdocreqtoupdate[0] !== "" ? multipostdocreqtoupdate.map(
                                dd=>(
                                    <tr key={dd.multipostid+1}>
                                        <td>{dd.multipostid}</td>
                                        <td>{dd.multiplepostdocrequired}</td>
                                        <td><button onClick={()=>{selectmultipostdocstoupdate(dd)}} >Edit</button></td>
                                        <td><button onClick={()=>{deletemultipostdocreq(dd.id)}}>Delete</button></td>
                                    </tr>
                                )
                            ): <tr>
                                    <td colSpan="3">**Multipost Documents not available**</td>
                                </tr>
                        }
                        
                    </tbody> 
                </table>
                <form className='multipostdocreqform' style={{display:"none"}} onSubmit={multipostdocrequpdatefun}>
                    <div style={{textAlign:"center"}}>
                        <h3>Multiposts Documents Update</h3>
                         <p className='multipostdocreqmsgshow' style={{textAlign:"center", color:"green", fontSize:"20px", fontWeight:"bold"}}></p>
                        <p className='multiposdocreq'></p>
                        <input readOnly type='text' placeholder='single job ID' value={multipostdocid !== undefined ? 'Multipost Id : '+multipostdocid : "Multipost Id : Na"}/>
                        <input name='multiplepostdocrequired' value={multipostdoctoupdate} onChange={(e)=>{setmultipostdoctoupdate(e.target.value)}} type='text' placeholder='Enter Documents'/>
                        <input type='submit' value='Update'/>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default UploadAllJobDetails; 